import deepmerge from "deepmerge";
import { useMemo } from "react";
import { useRouter } from "next/router";
import parseUrl from "parse-url";
import { defaultMetatags } from "@/lib/constants";
import config from "@/lib/config";
import Head from "next/head";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function mergeMetatags(defaultMetatags, metatags) {
  var _metatags$og, _metatags$og2, _metatags$twitter, _metatags$twitter2;

  if (!metatags) return defaultMetatags;
  var tags = deepmerge(defaultMetatags, metatags); // ogキーとtwitterキーにのtitle, descriptionキーにmetatagsのtitleとdescriptionを代入している（metaタグとogpタグでtitle, descriptionを重複させてる）（これやらないとdefaultMetatagsの内容になってしまう）

  if (!(metatags !== null && metatags !== void 0 && (_metatags$og = metatags.og) !== null && _metatags$og !== void 0 && _metatags$og.title) && metatags !== null && metatags !== void 0 && metatags.title) {
    tags.og.title = metatags.title;
  }

  if (!(metatags !== null && metatags !== void 0 && (_metatags$og2 = metatags.og) !== null && _metatags$og2 !== void 0 && _metatags$og2.description) && metatags !== null && metatags !== void 0 && metatags.description) {
    tags.og.description = metatags.description;
  }

  if (!(metatags !== null && metatags !== void 0 && (_metatags$twitter = metatags.twitter) !== null && _metatags$twitter !== void 0 && _metatags$twitter.title) && metatags !== null && metatags !== void 0 && metatags.title) {
    tags.twitter.title = metatags.title;
  }

  if (!(metatags !== null && metatags !== void 0 && (_metatags$twitter2 = metatags.twitter) !== null && _metatags$twitter2 !== void 0 && _metatags$twitter2.description) && metatags !== null && metatags !== void 0 && metatags.description) {
    tags.twitter.description = metatags.description;
  }

  return tags;
}

export default function DefaultHeader(_ref) {
  var adult = _ref.adult,
      metatags = _ref.metatags;
  var router = useRouter();
  var canonicalUrl = useMemo(function () {
    if (metatags !== null && metatags !== void 0 && metatags.canonicalUrl) {
      return metatags === null || metatags === void 0 ? void 0 : metatags.canonicalUrl;
    } else {
      var vodOrAdult = adult ? "adult" : "vod";
      var host = config.host[vodOrAdult];
      var parsed = parseUrl("".concat(host).concat(router.asPath));
      return "".concat(host).concat(parsed.pathname);
    }
  }, [router, adult]);

  var _useMemo = useMemo(function () {
    if (adult) {
      return ["/exicon", "#ff0db3", mergeMetatags(defaultMetatags.adult, metatags)];
    } else {
      return ["/icon", "#feff00", mergeMetatags(defaultMetatags.vod, metatags)];
    }
  }, [adult, metatags]),
      path = _useMemo[0],
      themeColor = _useMemo[1],
      tags = _useMemo[2];

  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("title", {
      children: (metatags === null || metatags === void 0 ? void 0 : metatags.title) || tags.title
    }, "title"), /*#__PURE__*/_jsx("link", {
      rel: "canonical",
      href: canonicalUrl
    }), /*#__PURE__*/_jsx("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1, user-scalable=no"
    }), /*#__PURE__*/_jsx("meta", {
      name: "keywords",
      content: tags.keywords
    }, "keywords"), /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: tags.description
    }, "description"), /*#__PURE__*/_jsx("meta", {
      property: "og:title",
      content: tags.og.title
    }, "ogtitle"), /*#__PURE__*/_jsx("meta", {
      property: "og:type",
      content: tags.og.type
    }, "ogtype"), /*#__PURE__*/_jsx("meta", {
      property: "og:url",
      content: tags.og.url
    }, "ogurl"), /*#__PURE__*/_jsx("meta", {
      property: "og:image",
      content: tags.og.image
    }, "ogimage"), /*#__PURE__*/_jsx("meta", {
      property: "og:site_name",
      content: tags.og.site_name
    }, "ogsite_name"), /*#__PURE__*/_jsx("meta", {
      property: "og:description",
      content: tags.og.description
    }, "ogdescription"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:card",
      content: tags.twitter.card
    }, "twittercard"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:title",
      content: tags.twitter.title
    }, "twittertitle"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:description",
      content: tags.twitter.description
    }, "twitterdescription"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:image",
      content: tags.twitter.image
    }, "twitterimage"), /*#__PURE__*/_jsx("meta", {
      name: "application-name",
      content: tags.appName
    }), /*#__PURE__*/_jsx("meta", {
      name: "msapplication-square70x70logo",
      content: "".concat(path, "/site-tile-70x70.png")
    }), /*#__PURE__*/_jsx("meta", {
      name: "msapplication-square150x150logo",
      content: "".concat(path, "/site-tile-150x150.png")
    }), /*#__PURE__*/_jsx("meta", {
      name: "msapplication-wide310x150logo",
      content: "".concat(path, "/site-tile-310x150.png")
    }), /*#__PURE__*/_jsx("meta", {
      name: "msapplication-square310x310logo",
      content: "".concat(path, "/site-tile-310x310.png")
    }), /*#__PURE__*/_jsx("meta", {
      name: "msapplication-TileColor",
      content: themeColor
    }), /*#__PURE__*/_jsx("meta", {
      name: "theme-color",
      content: themeColor
    }), !adult && /*#__PURE__*/_jsx("meta", {
      name: "apple-itunes-app",
      content: "app-id=1584808078"
    }), /*#__PURE__*/_jsx("link", {
      rel: "shortcut icon",
      href: "".concat(path, "/favicon.ico")
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-16x16.png"),
      sizes: "16x16"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-24x24.png"),
      sizes: "24x24"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-32x32.png"),
      sizes: "32x32"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-36x36.png"),
      sizes: "36x36"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-48x48.png"),
      sizes: "48x48"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-72x72.png"),
      sizes: "72x72"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-96x96.png"),
      sizes: "96x96"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-16x16.png"),
      sizes: "16x16"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-128x128.png"),
      sizes: "128x128"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-144x144.png"),
      sizes: "144x144"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-152x152.png"),
      sizes: "152x152"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-160x160.png"),
      sizes: "160x160"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-192x192.png"),
      sizes: "192x192"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-196x196.png"),
      sizes: "196x196"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-256x256.png"),
      sizes: "256x256"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-384x384.png"),
      sizes: "384x384"
    }), /*#__PURE__*/_jsx("link", {
      rel: "icon",
      type: "image/png",
      href: "".concat(path, "/icon-512x512.png"),
      sizes: "512x512"
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      sizes: "57x57",
      href: "".concat(path, "/apple-touch-icon-57x57.png")
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      sizes: "60x60",
      href: "".concat(path, "/apple-touch-icon-60x60.png")
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      sizes: "72x72",
      href: "".concat(path, "/apple-touch-icon-72x72.png")
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      sizes: "76x76",
      href: "".concat(path, "/apple-touch-icon-76x76.png")
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      sizes: "114x114",
      href: "".concat(path, "/apple-touch-icon-114x114.png")
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      sizes: "120x120",
      href: "".concat(path, "/apple-touch-icon-120x120.png")
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      sizes: "144x144",
      href: "".concat(path, "/apple-touch-icon-144x144.png")
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      sizes: "152x152",
      href: "".concat(path, "/apple-touch-icon-152x152.png")
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      sizes: "180x180",
      href: "".concat(path, "/apple-touch-icon-180x180.png")
    }), /*#__PURE__*/_jsx("link", {
      rel: "apple-touch-icon-precomposed",
      href: "".concat(path, "/apple-touch-icon.png")
    })]
  });
}